import './App.css';
import Routes from './routes/routes';

const App = () => <Routes />;

export default App;
